import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getMenuStyles = (theme: Theme) =>
    css({
        background: theme.palette.white,
        border: `1px solid ${theme.palette.secondary.dark}`,
        borderRadius: theme.borderRadius.S,
        position: 'relative',
        width: 'max-content',
        overflow: 'hidden',
        ...theme.elevations.popout1,
    });
